module.exports = "/img/call-center.svg?58d0f87f7f8822024280e658e8d51855";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/call-center.svg
// module id = Lsnc
// module chunks = 44